import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=ac2a208e&"
import script from "./Invoices.vue?vue&type=script&lang=js&"
export * from "./Invoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac2a208e')) {
      api.createRecord('ac2a208e', component.options)
    } else {
      api.reload('ac2a208e', component.options)
    }
    module.hot.accept("./Invoices.vue?vue&type=template&id=ac2a208e&", function () {
      api.rerender('ac2a208e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/welcome/actionItems/Invoices.vue"
export default component.exports